import { KnowledgeInputFragment } from '../../src/generated/graphql';
import { DocumentReference, DocumentUploadType } from './types';

export const buildDocumentServiceBaseUrl = (): URL | undefined => {
  const documentServiceBaseEndpoint = process.env.NEXT_PUBLIC_DOCUMENT_SERVICE;

  if (documentServiceBaseEndpoint) {
    return new URL(documentServiceBaseEndpoint);
  }

  console.error('Document service endpoint not configured');
  return undefined;
};

export const proxy_buildDocumentDownloadUrl = (
  clinicId: string,
  documentId: string,
  isGroup: boolean,
  isStatic: boolean,
): URL | undefined => {
  const ret = buildDocumentServiceBaseUrl();

  if (!ret) {
    return;
  }
  ret.pathname = `/document/download/${clinicId}/${documentId}`;

  const searchParams = ret.searchParams;

  searchParams.set('group', `${isGroup}`);
  searchParams.set('static', `${isStatic}`);

  return ret;
};

const documentUploadTypeToIdPropertyName = new Map<DocumentUploadType, string>([
  [DocumentUploadType.form, 'formRevisionGroupId'],
  [DocumentUploadType.appointmentTask, 'appointmentTaskId'],
]);

export const proxy_buildDocumentUploadUrl = (
  clinicId: string,
  uploadReference: DocumentReference,
  documentClass?: KnowledgeInputFragment,
): URL | undefined => {
  const ret = buildDocumentServiceBaseUrl();

  if (!ret) {
    return;
  }
  ret.pathname = '/document/upload';

  const searchParams = ret.searchParams;

  searchParams.set('clinicId', clinicId);
  searchParams.set(
    documentUploadTypeToIdPropertyName.get(uploadReference.type)!,
    uploadReference.referenceId,
  );
  if (uploadReference.formQuestionId) {
    searchParams.set('formQuestionId', uploadReference.formQuestionId);
  }

  if (documentClass?.generalId && documentClass?.text) {
    searchParams.set('classGeneralId', documentClass.generalId);
    searchParams.set('classText', documentClass.text ?? '');
  }

  return ret;
};
